module.exports = __webpack_public_path__ + "img/team-shield.4c8318c6.svg";